const imageConfig = [
  {
    main: `product/mattress/thesis/mattress-crop-small-dach.jpg`,
    mask: `product/mattress/thesis/mattress-mask-crop-small-dach.png`,
    shadow: `product/mattress/thesis/mattress-shadow-crop-small.png`,
    media: `(max-width: 419px)`,
    size: 377,
    width: 1384,
    height: 843,
  },
  {
    main: `product/mattress/thesis/mattress-crop-small-dach.jpg`,
    mask: `product/mattress/thesis/mattress-mask-crop-small-dach.png`,
    shadow: `product/mattress/thesis/mattress-shadow-crop-small.png`,
    media: `(min-width: 420px) and (max-width: 559px)`,
    size: 503,
    width: 1384,
    height: 843,
  },
  {
    main: `product/mattress/thesis/mattress-crop-small-dach.jpg`,
    mask: `product/mattress/thesis/mattress-mask-crop-small-dach.png`,
    shadow: `product/mattress/thesis/mattress-shadow-crop-small.png`,
    media: `(min-width: 560px) and (max-width: 767px)`,
    size: 690,
    width: 1384,
    height: 843,
  },
  {
    main: `product/mattress/thesis/mattress-crop-small-dach.jpg`,
    mask: `product/mattress/thesis/mattress-mask-crop-small-dach.png`,
    shadow: `product/mattress/thesis/mattress-shadow-crop-small.png`,
    media: `(min-width: 768px) and (max-width: 1023px)`,
    size: 921,
    width: 1384,
    height: 843,
  },
  {
    main: `product/mattress/thesis/mattress-crop-dach.jpg`,
    mask: `product/mattress/thesis/mattress-mask-crop-dach.png`,
    shadow: `product/mattress/thesis/mattress-shadow-crop.png`,
    media: `(min-width: 1024px) and (max-width: 1279px)`,
    size: 1023,
    width: 2053,
    height: 1015,
  },
  {
    main: `product/mattress/thesis/mattress-crop-dach.jpg`,
    mask: `product/mattress/thesis/mattress-mask-crop-dach.png`,
    shadow: `product/mattress/thesis/mattress-shadow-crop.png`,
    media: `(min-width: 1280px) and (max-width: 1599px)`,
    size: 1279,
    width: 2053,
    height: 1015,
  },
  {
    main: `product/mattress/thesis/mattress-dach.jpg`,
    mask: `product/mattress/thesis/mattress-mask-dach.png`,
    shadow: `product/mattress/thesis/mattress-shadow.png`,
    media: `(min-width: 1600px)`,
    size: 1600,
    width: 2611,
    height: 1129,
  },
];

export default imageConfig;
